import { createSelector } from 'reselect'
import { getUserID, getUserEmail, getUserRole } from 'selectors/user/session'
import { getAlgoliaDataPaginationCurrent, getSelectedFacets } from 'selectors/algolia2/data'
import { getCollectionTitle } from './algolia'
const dataDefaults = {
  userId: 0,
  userCategory: '',
  userEmail: '',
  environment: 'production',
  pageType: 'collection',
  subPageType: 'collectionBrowse',
  subSubPageType: '',
  pagination: 1,
}
export const getDataLayer = createSelector(
  [getUserID, getUserEmail, getUserRole, getSelectedFacets, getAlgoliaDataPaginationCurrent],
  (userId, userEmail, userRole, collectionTypes, currentPage) => {
    const data = { ...dataDefaults }
    data.userId = userId
    data.userCategory = userRole
    data.userEmail = userEmail
    data.pagination = currentPage + 1 || 1
    data.subSubPageType = collectionTypes.collection_types
    return data
  }
)
const breadcrumbSchema = {
  '@context': 'http://schema.org',
  type: 'BreadcrumbList',
  itemListElement: [
    {
      type: 'ListItem',
      position: 1,
      item: {
        '@id': '/',
        name: 'Home',
      },
    },
    {
      type: 'ListItem',
      position: 2,
      item: {
        '@id': '/all',
        name: 'All Artworks',
      },
    },
  ],
}
export const getMetaData = createSelector(
  [getCollectionTitle],
  (collectionType): Record<string, any> => {
    const title = `${collectionType} Collections | Saatchi Art`
    const description = `Explore ${collectionType.toLowerCase()} art collections curated by Saatchi Art.`
    return {
      description,
      title,
      og: {
        description,
        title,
        ttl: '2419200',
        type: 'article',
      },
      preloadImages: [],
      robots: true,
      schema: {
        webpage: {
          description,
          headline: title,
        },
        breadcrumb: breadcrumbSchema,
      },
    }
  }
)